export const CAPTCHA_CHALLENGES = ["v3-hide", "emcd-puzzle"];
